import styled from "styled-components/macro";
import Calendar from "react-calendar";

export const StyledCalendar = styled(Calendar)`
  font-family: "Inter", sans-serif;
  border: 1px solid var(--border-gray-light);
  border-radius: var(--rounded-corner);
  padding: 0.5rem;
  box-shadow: var(--drop-shadow);
  color: var(--dark-gray);
  min-width: 20rem;

  abbr {
    text-decoration: none;
  }

  .react-calendar__month-view__weekdays {
    font-weight: var(--font-weight-regular);
    font-size: var(--font-size-xxsmall);
  }

  .error {
    border-color: var(--error-color);
  }

  .react-calendar__navigation {
    height: auto;
    margin: 0.5rem 0;
  }

  .react-calendar__navigation__label {
    font-size: var(--font-size-medium);
    font-weight: var(--font-weight-medium);
  }

  button {
    color: var(--primary-black);
    font-size: var(--font-size-small);
  }
  .react-calendar__month-view__days__day--neighboringMonth {
    color: var(--gray);
    opacity: 0.4;
  }

  .react-calendar__tile:disabled {
    color: var(--gray);
    opacity: 0.4;
  }

  .react-calendar__tile:enabled:hover {
    background: var(--background-gray);
  }

  .react-calendar__navigation__arrow {
    font-size: var(--font-size-large);
  }

  .react-calendar__tile--now {
    background: var(--background-green);
    border-radius: var(--rounded-corner);
    color: var(--green);
  }
  .react-calendar__tile--now:hover {
    background: var(--background-green);
    color: var(--green);
  }

  .react-calendar__tile--active,
  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus,
  .react-calendar__tile--hasActive,
  .react-calendar__tile--hasActive:enabled:hover,
  .react-calendar__tile--hasActive:enabled:focus {
    color: white;
    background: var(--green);
    border-radius: var(--rounded-corner);
    box-shadow: var(--drop-shadow-light);
  }
`;
